import { render, staticRenderFns } from "./IssueList.vue?vue&type=template&id=2a3dde94&scoped=true"
import script from "./IssueList.vue?vue&type=script&lang=ts&setup=true"
export * from "./IssueList.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./IssueList.vue?vue&type=style&index=0&id=2a3dde94&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3dde94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a3dde94')) {
      api.createRecord('2a3dde94', component.options)
    } else {
      api.reload('2a3dde94', component.options)
    }
    module.hot.accept("./IssueList.vue?vue&type=template&id=2a3dde94&scoped=true", function () {
      api.rerender('2a3dde94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/proofreading/revising/IssueList.vue"
export default component.exports